import React, { createContext, useState, useEffect, useContext } from 'react';
import commonApi from '../utils/api';
import { useLocation, useNavigate } from 'react-router-dom';
import { CommonContext } from './CommonContext';

export const PickupPointsContext = createContext();

export function PickupPointsContextProvider({ children }) {
    const { user } = useContext(CommonContext);
    const [addModal, setAddModal] = useState(false);
    const [allData, setAllData] = useState([]);
    const [viewData, setViewData] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [allPickupPoints, setAllPickupPoints] = useState([]);
    const [firstLoading, setFirstLoading] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMesaage, setAlertMesaage] = useState('');
    const [severity, setSeverity] = useState('');
    const [filterType, setFilterType] = useState('contact person');
    const [searchValue, setSearchValue] = useState('');
    const [locationState, setLocationState] = useState(null);
    const navigate = useNavigate();

    const location = useLocation();
    const onCloseAlert = () => {
        setOpenAlert(false);
        setAlertMesaage('');
        setSeverity('')
    };

    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setViewData('');
        setAddModal(false);
    };
    const onLoadApi = () => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq = { merchant_id: user?.id }
        } else if (location?.state) {
            setLocationState(location.state)
            postReq = { merchant_id: location?.state?.id }
        } else {
            postReq = { admin_id: user?.id }
        }
        setFirstLoading(false);
        commonApi.post('/merchant-warehouse/list', postReq)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllPickupPoints(response?.data?.data);
                    setAllData(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };
    const onExport = () => {
        const payload = {};

        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id;
        } else {
            payload.merchant_id = user?.id;
        }
        if (searchValue) {
            payload.searchValue = searchValue;
            payload.searchBy = filterType;
        }
        setIsLoading(true);
        commonApi.post('/merchant-warehouse/export', payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMesaage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    navigate('/download');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setOpenAlert(true);
                setAlertMesaage(error?.message || error?.response?.data?.msg);
                setSeverity('error')
            });
    };
    useEffect(() => {
        onLoadApi();
    }, []);

    // You can provide any values or functions you want to make available to consumers here
    const contextValue = {
        filterType,
        setFilterType,
        searchValue,
        setSearchValue,
        onExport,
        locationState,
        setLocationState,
        onCloseAlert,
        severity,
        alertMesaage,
        openAlert,
        onLoadApi,
        firstLoading,
        isLoading,
        viewData,
        allPickupPoints,
        allData,
        handleAddModal,
        handleCloseModal,
        setAddModal,
        addModal,
        setAllData,
        setAllPickupPoints,
        setViewData,
        setIsLoading,
        setFirstLoading,
        setSeverity,
        setAlertMesaage,
        setOpenAlert,
    };

    // Render the provider with children
    return <PickupPointsContext.Provider value={contextValue}>{children}</PickupPointsContext.Provider>;
}
